export default {
  app: {
    display: 'flex',
    backgroundColor: 'white',
    minHeight: '100%',
    width: '100%',
    overflow: 'hidden',
    fontFamily: 'Open Sans',
  },
  content: {
    display: 'flex',
    flexGrow: 1,
    justifyContent: 'center',
    alignItems: 'center'
  },
  connecting: {
    marginRight: '10px',
    fontWeight: 'bold'
  }
}
